"use client";

const styles = {
  body: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: 0,
    padding: "0 1.5rem",
    background: "#0a0f1a",
    color: "#ffffff",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    textAlign: "center",
  },
  wrap: {
    display: "flex",
    maxWidth: "28rem",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.25rem",
  },
  h1: {
    margin: 0,
    fontSize: "1.5rem",
    fontWeight: 800,
    letterSpacing: "-0.02em",
  },
  p: {
    margin: 0,
    fontSize: "0.875rem",
    lineHeight: 1.6,
    color: "#b0b9c8",
  },
  code: {
    margin: 0,
    fontSize: "0.75rem",
    color: "#66748b",
  },
  button: {
    border: "none",
    borderRadius: "9999px",
    background: "#3b82f6",
    color: "#ffffff",
    padding: "0.75rem 1.5rem",
    fontSize: "0.875rem",
    fontWeight: 600,
    cursor: "pointer",
  },
} satisfies Record<string, React.CSSProperties>;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body style={styles.body}>
        <div style={styles.wrap}>
          <h1 style={styles.h1}>Něco se pokazilo</h1>
          <p style={styles.p}>
            Omlouváme se, stránku se nepodařilo načíst. Zkuste to prosím znovu.
          </p>
          {error.digest ? <p style={styles.code}>Kód: {error.digest}</p> : null}
          <button type="button" onClick={reset} style={styles.button}>
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
